import { state } from "./state";
import { setupResizer } from "./ui/resizer";
import { setupPanelControls, ensureSpaceKeyListener, setActiveListItem } from "./ui/controls";
import { setupFullscreenControls } from "./ui/fullscreen";
import { loadSpineEntries, setupFileDrop, handleLocalFiles } from "./core/file-loader";
import { createPlayer, handleSpineError } from "./core/player";
import { updateSpineDuration, updateSpineInfoBox } from "./ui/info-box";
import { initI18n, updateDOM } from "./i18n";

window.addEventListener('message', (event) => {
    const { type, payload, message } = event.data;
    
    if (type === 'frame') {
        if (payload) {
            updateSpineDuration(payload.duration, payload.time);
        }
    } else if (type === 'metadata') {
        if (state.currentActiveId) {
            updateSpineInfoBox(state.currentActiveId, payload);
        }
    } else if (type === 'success') {
        console.log("Spine player loaded successfully in iframe");
        state.currentPlayerProxy = {
            paused: false,
            play: () => { },
            pause: () => { }
        };
    } else if (type === 'error') {
        if (state.currentActiveId) {
             handleSpineError(state.currentActiveId, message);
        }
    } else if (type === 'zoom_delta') {
        const slider = document.getElementById("scale-range") as HTMLInputElement;
        if (slider) {
            let newVal = parseFloat(slider.value) + payload;
            newVal = Math.max(parseFloat(slider.min), Math.min(parseFloat(slider.max), newVal));
            slider.value = newVal.toFixed(1);
            slider.dispatchEvent(new Event('input')); 
        }
    }
});

async function initSpineViewer() {
  const i18n = await initI18n();
  updateDOM(i18n);

  const langSelector = document.getElementById("language-selector") as HTMLSelectElement | null;
  if (langSelector) {
    langSelector.value = i18n.language;
    langSelector.addEventListener("change", async (e) => {
      const target = e.target as HTMLSelectElement;
      await i18n.changeLanguage(target.value);
      updateDOM(i18n);
      
      // Update info box if active
      if (state.currentActiveId) {
         updateSpineInfoBox(state.currentActiveId);
      }
    });
  }

  setupResizer();
  setupPanelControls();
  setupFullscreenControls();
  setupFileDrop();

  const list = document.getElementById("spine-list") as HTMLUListElement | null;
  if (!list) {
    await loadSpineEntries();
    return;
  }

  ensureSpaceKeyListener();

  const entries = await loadSpineEntries();
  state.spineEntries = entries;

  list.innerHTML = "";

  entries.forEach((entry) => {
    const item = document.createElement("li");
    item.className = "spine-item";
    item.textContent = entry.name;
    item.dataset.id = entry.id;
    
    item.addEventListener("click", () => {
      if (state.currentActiveId === entry.id) return;
      state.currentActiveId = entry.id;
      setActiveListItem(entry.id);
      void createPlayer(entry);
    });
    list.appendChild(item);
  });

  const loadButton = document.getElementById("spine-load-btn") as HTMLButtonElement | null;
  const fileInput = document.getElementById("spine-file-input") as HTMLInputElement | null;

  if (loadButton && fileInput) {
    loadButton.addEventListener("click", () => {
      fileInput.value = "";
      fileInput.click();
    });

    fileInput.addEventListener("change", () => {
      if (fileInput.files) {
        void handleLocalFiles(fileInput.files, list);
      }
    });
  }
}

window.addEventListener("load", () => {
  void initSpineViewer();
});
